<template>
  <div>
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">验劵核销&nbsp;/&nbsp;</span>
      </div>
      <div>登记成功</div>
    </div>
    <div class="hexiao">
      <div class="hexiao-paySuccess"><img src="../../../assets/images/new/pay-success.png" alt=""></div>
      <div class="header-title">登记成功</div>
      <div class="mains-bottoms">
        <el-button @click="back">返回上一页</el-button>
        <el-button type="primary" @click="look">查看详情</el-button>
        <!-- <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doPageQuery"></paging> -->
      </div>
      <edit-set ref="editForm" @change="refreshPage"></edit-set>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editSet from "./detail";
export default {
  mixins: [minxin],
  components: {
    editSet
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    back() {
      let obj = JSON.parse(sessionStorage.getItem("verification"))
      let parmar = {
        payWayCode: obj.payWayCode,
        menuName: obj.menuName,
        appName: obj.appName,
        menuCode: obj.menuCode
      }
      this.$router.push({
        path: '/collectMoney/verification',
        query: parmar
      });
    },
    look () {
      this.$refs["editForm"].$emit("set", this.$route.query.qrUrl);
    },
    refreshPage () {
      
    }
  }
};
</script>
<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.hexiao {
  height: calc(100vh - 130px);
  margin: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #FFFFFF;
  border-radius: 10px;
  .hexiao-paySuccess {
    width: 68px;
    height: 68px;
    margin-top: 60px;
    margin-bottom: 60px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .header-title {
    margin-top: 8%;
    font-size: 24px;
  }
  .header-info {
    padding: 30px;
  }
}
.mains-bottoms {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
  margin-top: 60px;
  .back {
    margin: 10px 20px;
  }
}
</style>
